<style lang="scss" scoped>
.flv-player {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <canvas class="flv-player" controls ref="flv-player"></canvas>
</template>

<script>
// import  JSMpeg from "jsmpeg"
// import flvjs from "flv.js";
export default {
  name: "flv-player-ws",
  props: {
    url: String,
    type: String,
  },
  data() {
    return {
      flvPlayer: null,
      client: null
    };
  },
  watch: {
    url() {
      // this.destoryFlv()
      this.loadFlv()
    }
  },
  methods: {
    loadFlv() {
      if (this.flvPlayer) {
        this.destoryFlv()
      }
      if (!this.url) return;
      let url = `${process.env.VUE_APP_BASE_MONITOR}?url=` + btoa(this.url)
      // let url=`ws://192.168.4.70:9999/rtsp?url=`+btoa('rtsp://admin:mengtu@mingyu@192.168.3.163:554/stream1&channel=1')
      this.flvPlayer = new JSMpeg.Player(url, {
        canvas: this.$refs["flv-player"]
      })
      this.flvPlayer.play()
    },
    destoryFlv() {

      if (this.flvPlayer) {
        this.flvPlayer.destroy()
        this.flvPlayer=null
      }
    },

    stop() {
      if (this.flvPlayer) {
        this.flvPlayer.destroy();
        this.flvPlayer = null
      }
    },
    play() {
      if (this.flvPlayer) {
        this.flvPlayer.play();
      }
    },
  },
  mounted() {
    this.loadFlv();
  },
  destroyed() {
    this.destoryFlv();
  },
};
</script>
